<div class="order-sm-first d-flex flex-column">
  <input placeholder="Word length"
    class="form-control word-length-input"
    autocomplete="off"
    [ngClass]="mainInputCSSClass"
    (focus)="onFocus()"
    [value]="contentSearch"/>
  <pop-card
    *ngIf="showPopCard"
    (outsideClick)="closeDialog()"
    [customStyle]="{'width': '318px', 'margin-top': '-16px', 'margin-left': '-16px'}">
    <div class="row no-gutters p-3">
      <div class="col-12">
        <input id="selected-word-length" type="text" class="form-control" placeholder="Word length"
        [(ngModel)]="contentSearch"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="filterContents()"
        autofocus
        autocomplete="off"/>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12 content-list">
        <contents-list
          [section]="'standard'"
          [contents]="standardFilteredContents"
          [contentSearch]="contentSearch"
          (selectedContentOutput)="setSelectedContent($event)"
        ></contents-list>
        <hr *ngIf="showHr">
        <contents-list
          [section]="'customs'"
          [contents]="customFilteredContents"
          [contentSearch]="contentSearch"
          (selectedContentOutput)="setSelectedContent($event)"
        ></contents-list>
        <small *ngIf="showEmptyResultsMessage">
          <p>Hmm we don't offer that length. Try a 100-word increment from 300-4,000.</p>
          <p>Need a different length? We can help! Email <a href="support@verblio.com">support@verblio.com</a></p>
        </small>
      </div>
    </div>
  </pop-card>
</div>